import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import { FormWrapper } from '@Root/HOCs'
import { Field } from '@Root/components'
import { useError, useToggle } from '@Root/hooks'

const titles = { onEdit: 'Edit the Entry Qualification Subject', onRead: 'Entry Qualification Subject Details', onCreate: 'Create Entry Qualification Subject' }
export const EntryQualificationSubjectForm = ({
  canEdit,
  canDelete,
  onDelete,
  onSave,
  onCancel,
  isNew,
  initialValue,
  isLoading,
  isSuccess,
  options,
  descriptions,
  onOpenDescriptionModal,
}) => {
  const [data, setData] = useState({})
  const { errors, setError } = useError()
  const [isEditable, toggleEditable] = useToggle(Boolean(isNew))

  useEffect(() => {
    if (isSuccess) toggleEditable()
  }, [isSuccess])

  useEffect(() => {
    if (initialValue) setData(initialValue)
  }, [initialValue])

  const validateForm = () => {
    const { subject_identifier_id } = data
    if (!subject_identifier_id) {
      setError('subject_identifier_id', 'Required')
      return false
    }
    return true
  }

  const onChangeValue = field => value => {
    setData(prevState => ({ ...prevState, [field]: value }))
  }

  const onChangeMode = () => {
    toggleEditable()
  }

  const onCancelEditMode = () => {
    onChangeMode()
    setData(initialValue)
  }

  const onSubmitForm = () => {
    if (!validateForm()) return
    onSave(data)
  }

  const onCancelEdit = () => {
    if (!isNew) {
      onCancelEditMode()
      return
    }
    onCancel()
  }

  const { subject_identifier_id } = data

  const { subject_identificators } = options
  const { onEdit, onRead, onCreate } = titles

  return (
    <div className={styles.form}>
      <FormWrapper
        buttons={isEditable ? ['cancel', ...(canDelete ? ['delete'] : []), 'save'] : []}
        buttonsNames={[{ button: 'delete', name: 'Delete this entry qualification subject' }]}
        buttonsAreDisabled={isLoading}
        isSpinning={isLoading}
        clickCancelButtonHandler={onCancelEdit}
        clickDeleteButtonHandler={onDelete}
        clickSaveButtonHandler={onSubmitForm}
        editTitle={onEdit}
        readTitle={onRead}
        createTitle={onCreate}
        clickToggleEditModeButtonHandler={onChangeMode}
        isEditable={isEditable}
        canEdit={canEdit}
        isCreate={isNew}
        idForm={data?.id ? `qualification_subject_${data?.id}` : null}
        isSuccess={isSuccess}
      >
        <div className={styles.grid}>
          <div className={styles.column}>
            <div className={styles.row}>
              <Field
                label={'Subject identifier'}
                classNames={!isEditable ? ['borderless'] : []}
                style={{ width: 260 }}
                value={subject_identifier_id}
                field={'select'}
                onChange={onChangeValue('subject_identifier_id')}
                placeholder='Subject identifier'
                isDisabled={!isEditable}
                options={subject_identificators}
                optionsStyle={{ width: 260, overflow: 'inherit' }}
                error={errors.subject_identifier_id}
                isRequired
                search={true}
                description={descriptions?.subject_identifier_id}
                onOpenDescriptionModal={onOpenDescriptionModal}
              />
            </div>
          </div>
        </div>
      </FormWrapper>
    </div>
  )
}
